module.exports = __webpack_public_path__ + "img/032.c0e25b15.jpg";